import React, { Fragment } from 'react'

export const headerProps = {
  text: (
    <Fragment>
      <span>Abhishek Palit   </span>
    </Fragment>
  ),
  text1: (
    <Fragment>
      <span>Architecture Technology &amp; Sustainability</span>
    </Fragment>
  ),
  text2: (
    <Fragment>
      <span>home</span>
    </Fragment>
  ),
  text3: (
    <Fragment>
      <span>articles</span>
    </Fragment>
  ),
  text4: (
    <Fragment>
      <span>projects</span>
    </Fragment>
  ),
  text5: (
    <Fragment>
      <span>articles</span>
    </Fragment>
  ),
  button: (
    <Fragment>
      <span>about me</span>
    </Fragment>
  ),
  text21: (
    <Fragment>
      <span>projects</span>
    </Fragment>
  ),
  button1: (
    <Fragment>
      <span>about me</span>
    </Fragment>
  ),
}
